import { CourseResourceApi, courseResourcesApi } from "api";
import { ModalHeader } from "../../../components/templates/Modals/ModalHeader";
import { ModalPadding } from "../../../components/templates/Modals/ModalPadding";
import { PaziaModal } from "components/molecules";
import { appendFileToBrowser } from "utils";
import { COURSE_RESOURCE_TYPE } from "./ResourceForm";
import { YouTubeEmbedResource } from "../preview/YouTubeEmbedResource";
import { YouTubeThumbnailResource } from "../preview/YouTubeThumbnailResource";
import { useState } from "react";
import { PdfBlobPreviewModal } from "pages/Finances/PdfBlobPreviewModal";

interface PreviewResourceModalProps {
  onCloseRequest: () => void;
  courseId: number;
  resource: CourseResourceApi | null;
}

export const PreviewResourceModal = ({ courseId, onCloseRequest, resource }: PreviewResourceModalProps) => {
  const [processing, setProcessing] = useState(false);

  const onDownload = async () => {
    if (!resource) return;
    setProcessing(true);
    let apiResponse = null;
    try {
      const response = await courseResourcesApi.download(courseId, resource.id);
      apiResponse = response;
      const extensionFromLink = resource.link.split(".").pop();
      const nameWithoutSpaces = resource.name.replace(/\s/g, "_");
      const name = `${nameWithoutSpaces}.${extensionFromLink}`;
      appendFileToBrowser(response.data, name);
    } catch (error) {
      console.error(error, apiResponse);
    } finally {
      setProcessing(false);
    }
  };

  return (
    <>
      <PdfBlobPreviewModal
        blobName={resource?.type == COURSE_RESOURCE_TYPE.INTERNAL_BLOB_FILE ? resource.link : null}
        containerType="COURSE_RESOURCES"
        onCloseRequest={() => {
          onCloseRequest();
        }}
      />
      <PaziaModal
        id="add-resource-modal"
        onCloseRequest={() => {
          onCloseRequest();
        }}
        isOpen={resource !== null && resource?.type != COURSE_RESOURCE_TYPE.INTERNAL_BLOB_FILE}
        size="lg"
      >
        <ModalPadding>
          <ModalHeader>Podgląd materiału</ModalHeader>
          {resource?.type == COURSE_RESOURCE_TYPE.YOU_TUBE_VIDEO_EMBED && (
            <YouTubeEmbedResource name={resource.name} description={resource.description ?? ""} link={resource.link} />
          )}
          {resource?.type == COURSE_RESOURCE_TYPE.YOU_TUBE_VIDEO_THUMBNAIL && (
            <YouTubeThumbnailResource
              name={resource.name}
              description={resource.description ?? ""}
              link={resource.link}
            />
          )}
          {resource?.type == COURSE_RESOURCE_TYPE.EXTERNAL_LINK && (
            <div>
              <p className="text-lg">{resource.name}</p>
              <p className="text-slate-500">{resource.description}</p>
              <a href={resource.link} target="_blank" rel="noreferrer" className="text-primary-500">
                {resource.link}
              </a>
            </div>
          )}
          {/* {resource?.type == COURSE_RESOURCE_TYPE.INTERNAL_BLOB_FILE && (
            <div>
              <p className="text-lg">{resource.name}</p>
              <p className="text-slate-500">{resource.description}</p>
              {processing ? (
                <LoadingSpinner />
              ) : (
                <div onClick={onDownload} className="text-primary-500 cursor-pointer">
                  Pobierz
                </div>
              )}
            </div>
          )} */}
        </ModalPadding>
      </PaziaModal>
    </>
  );
};

const LoadingSpinner = () => {
  return (
    <svg className="ml-auto h-4 w-4 shrink-0 animate-spin fill-current" viewBox="0 0 16 16">
      <path d="M8 16a7.928 7.928 0 01-3.428-.77l.857-1.807A6.006 6.006 0 0014 8c0-3.309-2.691-6-6-6a6.006 6.006 0 00-5.422 8.572l-1.806.859A7.929 7.929 0 010 8c0-4.411 3.589-8 8-8s8 3.589 8 8-3.589 8-8 8z" />
    </svg>
  );
};
